import { computeSize as _computeSize } from '../../utils/object-utilities';
import { DEFAULT_SIZE } from './styled';

const XS = 'XS';
const S = 'S';
const SMALL = 'SMALL';
const M = 'M';
const MEDIUM = 'MEDIUM';
const L = 'L';
const LARGE = 'LARGE';
const XL = 'XL';

export const IconSizes = {
  XS,
  S,
  SMALL,
  M,
  MEDIUM,
  L,
  LARGE,
  XL
};

const SIZE_MAPPER = {
  [XS]: '12px',
  [S]: '16px',
  [SMALL]: '16px',
  [M]: '24px',
  [MEDIUM]: '24px',
  [L]: '32px',
  [LARGE]: '32px',
  [XL]: '64px'
};

export const computeSize = propSize => _computeSize(propSize, SIZE_MAPPER, DEFAULT_SIZE);
